export const PERMISSIONS = {

    PERSONA_FISICA_VIEW: 'persona-fisica_view',
    PERSONA_FISICA_EDIT: 'persona-fisica_edit',
    PERSONA_JURIDICA_VIEW: 'persona-juridica_view',
    PERSONA_JURIDICA_EDIT: 'persona-juridica_edit',
    EXPEDIENTE_VIEW: 'expediente_view',
    EXPEDIENTE_EDIT: 'expediente_edit',
    LISTAS_ADMINISTRACION_VIEW: 'listas_administracion_view',
    LISTAS_ADMINISTRACION_EDIT: 'listas_administracion_edit',

};
